import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    padding: 10px;
`;

export const DivFlex = styled.div`
    display: flex;
    flex: 9;
    flex-direction: column;
    gap: 8px;
`;

export const RightArrowIconFlex = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
`;

export const RowFlex = styled.div`
    display: flex;
    width: 100%;
`;

export const Value1 = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
`;

export const Value2 = styled.div<{ label: boolean }>`
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    color: #040222;
`;

export const Value3 = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;a
`;

export const Value4 = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
    margin-left: 6px;
`;

export const Value5 = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const Value6 = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;
`;

export const Value4BackgroundText = styled.div<{ background: string }>`
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    background-color: ${(props) => props.background};
    color: ${(props) => props.color};
    padding: 2px 6px;
    border-radius: 4px;
`;
